import React, { ReactElement, useEffect, forwardRef, useRef } from 'react';
import styles from './ute-document-search-box.module.scss';
import UTEButton from '../ute-button';
import SearchIcon from 'src/assets/svg/search-icon';
import CloseIcon from 'src/assets/svg/close-icon';
import DocumentSearchLeftArrowIcon from '../../assets/svg/document-search-arrow-left-icon';
import DocumentSearchRightArrowIcon from '../../assets/svg/document-search-arrow-right-icon';

type UTEDocumentSearchBoxProps = {
	id?: string;
	name?: string;
	searchText: string;
	placeholderText?: string;
	searchIcon?: ReactElement<any, any>;
	disabled: boolean;
	searchOnClick?: boolean;
	showClearButton?: boolean;
	totalWidth?: string;
	height?: string;
	maxLength?: number;
	className?: string;
	onChangeSearchText: (searchText: string) => void;
	onSearch: () => void;
	onClearSearch: () => void;
	navigateToPreviousSearch: () => void;
	navigateToNextSearch: () => void;
	totalMatchCount: number;
	searchIndex: number;
};
const UTEDocumentSearchBox = React.forwardRef<HTMLInputElement, UTEDocumentSearchBoxProps>(({
	id,
	name,
	searchText,
	placeholderText,
	searchIcon,
	disabled,
	searchOnClick,
	showClearButton,
	totalWidth,
	height,
	maxLength,
	className,
	onChangeSearchText,
	onSearch,
	onClearSearch,
	navigateToNextSearch,
	navigateToPreviousSearch,
	totalMatchCount,
	searchIndex,
}, ref) => {
	useEffect(() => {}, [searchText]);

	return (
		<div
			className={`${styles.searchContainer} ${className ?? ''}`}
			style={{ width: totalWidth ?? '269px', height: height ?? '31px' }}>
			<input
				ref={ref}
				type='text'
				id={id ?? 'searchText'}
				name={name ?? 'searchText'}
				placeholder={placeholderText ?? 'Search'}
				maxLength={maxLength ?? 300}
				onChange={(e) => {
					onChangeSearchText(e.target.value);
				}}
				value={searchText}
			/>
			<span className={`${styles.ellipses}`}>
				{searchText.length > 13 ? searchText.slice(0, 12) + '...' : searchText}
			</span>
			<UTEButton
				className={`${styles.searchIcon} ${searchOnClick ? '' : styles.noSearchOnClick}`}
				text=''
				icon={searchIcon ?? <SearchIcon />}
				onClick={() => {
					searchOnClick && onSearch();
				}}
				disabled={searchOnClick ? disabled ?? false : false}
				dataTestAuto='4038f673-abba-462f-abb9-0f8de164c11a'
			/>
			<div className={styles.matchText}>
				{searchIndex}/{totalMatchCount}
			</div>
			<div
				className={`${styles.arrowLeftButton} ${!searchText ? styles.disabled : ''}`}
				onClick={() => {
					navigateToPreviousSearch();
				}}
				title='Previous'>
				<DocumentSearchLeftArrowIcon />
			</div>
			<div
				className={`${styles.arrowRightButton} ${!searchText ? styles.disabled : ''}`}
				onClick={() => {
					navigateToNextSearch();
				}}
				title='Next'>
				<DocumentSearchRightArrowIcon />
			</div>
			{showClearButton && (
				<div
					className={styles.clearSearch}
					onClick={onClearSearch}>
					<CloseIcon />
				</div>
			)}
		</div>
	);
});

export default UTEDocumentSearchBox;
